<template>
  <div class="meeting-display">
    <h3>{{ $t('home.meeting.meetingScheduled.title') }}</h3>
    <div class="meeting-display__body" v-if="demand">
      <div class="meeting-display__body__panel"  :class="{'no-buttons': !isBouttonsDisplayed}">
        <img class="meeting-display__body__panel__image" :src="imageSrc">
        <p class="meeting-display__body__panel__text">
          <span>
            {{ $t('home.meeting.meetingScheduled.pre') }}
            <b>{{ type }}</b>
            {{$t('home.meeting.meetingScheduled.the') }}
          </span>
          <span class="meeting-display__body__panel__text--bold">
            {{ meetingDate }}
          </span>
          <span>{{ $t('home.meeting.meetingScheduled.end', {name: meetingExpert}) }}</span>
          <br>
          <span class="meeting-display__body__panel__text--calendar">
            {{ $t('home.meeting.meetingScheduled.addToCalendar') }}
            <a
              target="_blank"
              class="link"
              :href="gmailUrl">
              {{ $t('home.meeting.meetingScheduled.googleCalendar') }}
            </a>
            <a
              class="link"
              download="invite.ics"
              :href="icsUrl">
              {{ $t('home.meeting.meetingScheduled.appleCalendar') }}
            </a>
          </span>
        </p>
      </div>
      <div class="meeting-display__body__explanation">
        <p>{{ $t('home.meeting.meetingScheduled.explanationText') }}</p>
        <p
          class="meeting-display__body__explanation--bold"
          :class="{'hidden': !isBouttonsDisplayed}">
          {{ demand.meeting.meeting_type !== 'MEETING_TYPE_VAD'
            ? $t('home.meeting.meetingScheduled.cancelText')
            : $t('home.meeting.meetingScheduled.cancelTextDomicile') }}
        </p>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';

const ics = require('ics');

export default {
  name: 'meetingDisplay',
  props: {
    isBouttonsDisplayed: {
      type: Boolean,
    },
  },
  data() {
    return {
      icsUrl: '',
    };
  },
  computed: {
    ...mapGetters({
      demand: 'demandStore/demand',
    }),
    type() {
      const types = {
        MEETING_TYPE_TEL: this.$t('home.meeting.meetingScheduled.tel'),
        MEETING_TYPE_VISIO: this.$t('home.meeting.meetingScheduled.visio'),
        MEETING_TYPE_VAD: this.$t('home.meeting.meetingScheduled.homeVisit'),
        MEETING_TYPE_UNKNOWN: '',
      };
      return types[this.demand.meeting.meeting_type] || '';
    },
    imageSrc() {
      const date = new Date(this.demand.meeting.meeting_date);
      const day = this.formatNumber(date.getDate());
      const month = this.formatNumber(date.getMonth() + 1);
      return `https://backend.nextories.com/images/calendars/new/${month}-${day}.png`;
    },
    meetingDate() {
      const dateTxt = this.formatDate(this.demand.meeting.meeting_date);
      const date = new Date(this.demand.meeting.meeting_date);
      const meeting = {
        date: dateTxt,
        hours: this.formatNumber(date.getHours()),
        minutes: this.formatNumber(date.getMinutes()),
      };
      return this.$t('home.meeting.meetingScheduled.meeting', meeting);
    },
    meetingExpert() {
      let firstName = this.demand.assigned_user ? this.demand.assigned_user.first_name : '';
      let lastName = this.demand.assigned_user ? this.demand.assigned_user.last_name : '';
      if (this.demand.meeting && this.demand.meeting.expert) {
        firstName = this.demand.meeting.expert.first_name;
        lastName = this.demand.meeting.expert.last_name;
      }
      return `${firstName} ${lastName}`;
    },
    gmailUrl() {
      const eventName = 'RDV+Nextories';
      const start = this.demand.meeting.meeting_date;
      const end = new Date(this.demand.meeting.meeting_date).getTime()
        + this.demand.meeting.duration_hours * 60 * 60 * 1000
        + this.demand.meeting.duration_minutes * 60 * 1000;
      const dates = `${this.formatDateGoogle(start)}/${this.formatDateGoogle(end)}`;
      const details = 'Rdv+avec+votre+expert+en+déménagement';
      return `https://calendar.google.com/calendar/r/eventedit?text=${eventName}&dates=${dates}&details=${details}`;
    },
  },
  methods: {
    formatDate(date) {
      const d = new Date(date);
      const day = d.getDate() < 10 ? `0${d.getDate()}` : d.getDate();
      const month = d.getMonth() + 1 < 10 ? `0${d.getMonth() + 1}` : d.getMonth() + 1;
      const year = d.getFullYear();
      return `${day}/${month}/${year}`;
    },
    formatDateGoogle(date) {
      const d = new Date(date);
      const year = d.getUTCFullYear();
      const month = this.formatNumber(d.getUTCMonth() + 1);
      const days = this.formatNumber(d.getUTCDate());
      const hours = this.formatNumber(d.getUTCHours());
      const minutes = this.formatNumber(d.getUTCMinutes());
      const seconds = this.formatNumber(d.getUTCSeconds());
      return `${year}${month}${days}T${hours}${minutes}${seconds}Z`;
    },
    formatNumber(number) {
      return number > 9 ? number : `0${number}`;
    },
    getIcs() {
      const start = new Date(this.demand.meeting.meeting_date);
      const event = {
        start: [
          start.getFullYear(),
          start.getMonth() + 1,
          start.getDate(),
          start.getHours(),
          start.getMinutes(),
        ],
        duration: {
          hours: this.demand.meeting.duration_hours,
          minutes: this.demand.meeting.duration_minutes,
        },
        title: 'RDV Nextories',
        description: '',
        location: '',
        url: 'https://www.nextories.com/',
        status: 'CONFIRMED',
        busyStatus: 'BUSY',
      };
      return new Promise((resolve, reject) => {
        ics.createEvent(event, (error, value) => {
          if (error) return reject(error);
          return resolve(value);
        });
      });
    },
  },
  async created() {
    this.icsUrl = `data:text/plain;charset=utf-8,${encodeURIComponent(await this.getIcs())}`;
  },
};
</script>

<style scoped lang="scss">
.meeting-display {
  &__body {
    display: flex;
    align-items: center;
    justify-content: center;
    margin: 10px 0;
    flex-direction: column;
    @include breakpoint(mobile) {
      margin: 40px 0;
    }
    @include breakpoint(tablet) {
      margin: 40px 80px 0;
    }

    &__panel {
      border-radius: 4px;
      text-transform: uppercase;
      font-size: 20px;
      padding: 20px 0;
      margin: 10px 0;
      background-color: $--color-panel;
      display: flex;
      flex-direction: column;
      @include breakpoint(mobile) {
        font-size: 27px;
        flex-direction: row;
      }
      &__image {
        margin: 20px auto;
        @include breakpoint(mobile) {
          margin: auto 0 auto 40px;
        }
      }
      &__text {
        text-align: center;
        margin: auto 20px;
        @include breakpoint(mobile) {
          text-align: left;
          margin: auto 40px;
        }
        flex: 1 1 auto;
        &--calendar {
          text-transform: none;
          font-size: 16px;
          a {
            margin: 0 5px;
          }
        }
        &--bold {
          font-weight: 700;
        }
      }
    }
    &__explanation {
      .hidden {
        display: none;
      }
      &--bold {
        font-weight: 700;
        color: $--color-secondary;
        margin-bottom: 20px;
        @include breakpoint(mobile) {
          margin-bottom: 0;
        }
      }
    }
    .no-buttons {
      margin-top: 20px;
    }
  }
}
</style>
